// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab49b8e4","455":"632802b9","977":"4478cf53"}[chunkId] + ".chunk.js";
};